const isMac = (navigator = window.navigator) => navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export { isMac };
